










































import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';
import { SwIconTabDivider } from '../sw-icon-tab';
import { ChipItem } from './types';
import SwChip from './sw-chip.vue';
import { VueRenderFunction } from '../common-types';

const cssPrefix = 'sw-chip-group';

/**
 * @event request-remove `(chipId: string)`
 */
@Component({
  components: {
    SwChip,
    SwIconTabDivider,
  },
})
export default class SwChipGroup extends SwExtendedVue {
  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: [String, Function], required: true })
  label: string | VueRenderFunction;

  @Prop({ type: Array, required: true })
  chips: ChipItem[];

  @Prop({ type: Number, default: -1 })
  limit: number;

  cssPrefix = cssPrefix;

  get toShowChips(): ChipItem[] {
    if (this.limit <= 0) { return this.chips; }
    return this.chips.slice(0, this.limit);
  }

  get showEllipsis(): boolean {
    return this.toShowChips.length < this.chips.length;
  }

  get dividerColor() {
    return this.theme === 'light' ? utilService.colorConst.light_icon : utilService.colorConst.dark_icon;
  }

  private onRequestRemoveChip(chip: ChipItem) {
    this.$emit('request-remove', chip.id);
  }

  private render(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div
        class={[`${this.cssPrefix}`, `${this.cssPrefix}--${this.theme}`, 'sw-typo-default',
          'sw-flexbox', 'sw-flexbox--inline', 'sw-flexbox--center-items',
        ]}
      >
        <span class={[`${this.cssPrefix}__label`, 'sw-flexbox__flex-none']}>{
          (typeof this.label === 'function') ? this.label(h) : this.label
        }</span>
        <sw-icon-tab-divider width={20} color={this.dividerColor} class={['sw-flexbox__flex-none']} />
        <div class={[`${this.cssPrefix}__chips-cont`, 'sw-flexbox__flex-none', 'sw-flexbox', 'sw-flexbox--center-items']}>
        {
          this.toShowChips.map(chip => (
            <sw-chip
              key={chip.id}
              class={[`${this.cssPrefix}__chip`, 'sw-flexbox__flex-none']}
              theme={this.theme}
              with-close={(typeof chip.withClose === 'boolean') ? chip.withClose : true}
              on-request-remove={() => { this.onRequestRemoveChip(chip); }}
            >{
              (typeof chip.label === 'function') ? chip.label(h) : chip.label
            }</sw-chip>
          ))
        }
        {
          this.showEllipsis ? (
            <span class={[`${this.cssPrefix}__ellipsis`, 'sw-flexbox__flex-none']}>...</span>
          ) : undefined
        }
        </div>
        <span class={[`${this.cssPrefix}__terminate`, 'sw-flexbox__flex-none']}>;</span>
      </div>
    ) as VNode;
  }
}
